__turbopack_context__.v({
  "basic": "Table-module__NRUoka__basic",
  "caption": "Table-module__NRUoka__caption",
  "comparison": "Table-module__NRUoka__comparison",
  "scroll": "Table-module__NRUoka__scroll",
  "spec": "Table-module__NRUoka__spec",
  "table": "Table-module__NRUoka__table",
});
